export const NotificationIDs = {
  AppInstall: 10,
};
